import styled from 'styled-components';

import { getCombinedClassNames } from 'utils/style';
import themConfigs from 'config/theme';

const fullConfig = { theme: themConfigs };

const AudienceSplitPageWrap = styled.div.attrs(() => {
  const classNamesToAdd = ['w-full', 'bg-cover', 'bg-center', 'relative'];
  return {
    className: getCombinedClassNames(classNamesToAdd),
  };
})`
  min-height: calc(100vh - 64px);
  @media (min-width: ${fullConfig.theme.screens.sm}) {
    min-height: calc(100vh - 67px);
  }
  @media (min-width: ${fullConfig.theme.screens.md}) {
    background-image: url(${({ bgImage }) => bgImage.md.url});
  }
  @media (min-width: ${fullConfig.theme.screens.lg}) {
    min-height: calc(100vh - 90px);
  }
  @media (min-width: ${fullConfig.theme.screens.xl}) {
    background-image: url(${({ bgImage }) => bgImage.xl.url});
  }
  @media (min-width: ${fullConfig.theme.screens.xxl}) {
    min-height: calc(100vh - 108px);
  }
`;

// eslint-disable-next-line import/prefer-default-export
export { AudienceSplitPageWrap };
